// Tenant › Signup (owner, November 3: a signup is a tenant, so what Ops knows
// about the signup is on its tenant page). Only on a tenant that came through
// the signup on scorelm.com (tenant.signup_id): who signed up, where they came
// from, the cleanup and its Keep switch while it hasn't paid, their
// organisation, the Growth lead, and notes with every email and reply. Writing
// to them is the Email tab.

import { Navigate } from 'react-router-dom'
import { api } from '@/api'
import { ErrorState, LoadingState } from '@/components/ui'
import { invalidateQueries, setQueryData, useQuery } from '@/lib/query'
import { Cleanup, LeadCard, Organisation, Person, Timeline, WhereFrom } from '@/pages/signups/SignupCards'
import { signupKey } from '@/pages/signups/signupData'
import { useTenant } from '../tenantContext'

export default function SignupTab() {
  const { tenant } = useTenant()
  const id = tenant.signup_id ?? null
  const q = useQuery(id ? signupKey(id) : null, (signal) => api.growth.signups.get(id!, signal))
  if (!id) return <Navigate to="../overview" replace />
  if (q.status === 'error' && !q.data) return <ErrorState error={q.error} title="Couldn't load the signup" onRetry={q.refetch} />
  const signup = q.data
  if (!signup) return <LoadingState label="Loading the signup…" />

  const reload = () => invalidateQueries('signups')
  return (
    <div className="grid items-start gap-4 lg:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)]">
      <div className="grid min-w-0 content-start gap-4">
        <Person signup={signup} title="Signed up by" withLeague={false} />
        <Timeline signup={signup} onNote={reload} />
      </div>
      <div className="grid min-w-0 content-start gap-4">
        {signup.lifecycle.state !== 'paid' ? <Cleanup signup={signup} onChange={(next) => setQueryData(signupKey(id), next)} /> : null}
        <WhereFrom signup={signup} />
        <Organisation signup={signup} />
        <LeadCard signup={signup} onAdded={reload} />
      </div>
    </div>
  )
}
